<template>
  <v-dialog v-model="commentsDialog" width="900" dark scrollable>
    <template #activator="{ on }">
      <div class="comments-triggerer py-3 px-6" v-on="on">
        <div>
          <v-icon small class="mr-3">
            fal fa-comments
          </v-icon>
          Comments ({{ photo.numberOfComments }})
        </div>
      </div>
    </template>
    <perfect-scrollbar :options="{ suppressScrollX: true }">
      <v-card outlined>
        <v-card-text class="pt-4">
          <Comments
            :me="me"
            :photo="photo"
            :comments="comments"
            :is-last-page="isLastPage"
            :page="page"
            :loading="loading"
            :dark="true"
          />
        </v-card-text>
      </v-card>
    </perfect-scrollbar>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import Comments from '@/components/photo/Comments.vue'

export default {
  name: 'CurationPanelComments',
  components: {
    Comments
  },
  props: {
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    photo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      commentsDialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState({
      comments: state => state.comments.list,
      isLastPage: state => state.comments.isLastPage,
      page: state => state.comments.page
    })
  },
  watch: {
    commentsDialog: 'checkCommentsDialog'
  },
  methods: {
    async checkCommentsDialog(value) {
      if (
        value &&
        this.comments.length === 0 &&
        !this.loading &&
        !this.isLastPage
      ) {
        try {
          this.loading = true
          await this.$store.dispatch('comments/getPhotoComments', {
            page: 1,
            id: this.photo.id
          })
        } catch (error) {
          this.$asa.appInsights('Comp: account/curation/panels/Comments.vue - method: checkCommentsDialog', error)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style scoped>
.comments-triggerer {
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 0 0 4px 4px;
  border-top: none;
}
.comments-triggerer:hover {
  background-color: #303030;
  cursor: pointer;
}
.ps {
  height: auto;
}
</style>
